module.exports = __webpack_public_path__ + "static/media/asiconnect.fe50ea69.jpg";